import { Expose } from 'class-transformer';
import { DropdownModel } from './dropdown-model.model';

export class AppDropdown extends DropdownModel {
  @Expose() name: string;
  @Expose() value: any;
  
  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): any {
    return this.value;
  }
}
